// extracted by mini-css-extract-plugin
export default {"bottomBarDiv":"calculator-bottom-bar_bottomBarDiv__aRRiK"};